module.exports = __webpack_public_path__ + "img/old1.05f278d6.jpg";